// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-table[data-v-67ec8859] {\n  padding-left: 50px;\n}\n.form-conrtol[data-v-67ec8859] {\n  width: 100%;\n}\n[data-v-67ec8859] .vxe-body--column {\n  height: 50px !important;\n}\n.pagination[data-v-67ec8859] {\n  margin-top: 10px;\n  display: flex;\n  justify-content: flex-end;\n}\n[data-v-67ec8859] .el-pagination.is-background .el-pager li:not(.disabled).active {\n  color: white !important;\n}\n", ""]);
// Exports
module.exports = exports;
